import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useGamePhase } from '../hooks/useGamePhase';
export function PhaseRenderer({ intro, demo, calibrationWarmup, staircase, wrapUp, debrief, paused, aborted, fallback = null, }) {
    const { phase } = useGamePhase();
    let content = fallback;
    switch (phase) {
        case 'intro':
            content = intro ?? fallback;
            break;
        case 'demo':
            content = demo ?? fallback;
            break;
        case 'calibration_warmup':
            content = calibrationWarmup ?? fallback;
            break;
        case 'staircase':
            content = staircase ?? fallback;
            break;
        case 'wrap_up':
            content = wrapUp ?? fallback;
            break;
        case 'debrief':
            content = debrief ?? fallback;
            break;
        case 'paused':
            content = paused ?? fallback;
            break;
        case 'aborted':
            content = aborted ?? fallback;
            break;
    }
    return _jsx(_Fragment, { children: content });
}
//# sourceMappingURL=PhaseRenderer.js.map